/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserCenterJoinsDto } from '../../models/user-center-joins-dto';

export interface GetUserControllerGetJoin$Params {
  query?: string;
}

export function getUserControllerGetJoin(http: HttpClient, rootUrl: string, params?: GetUserControllerGetJoin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserCenterJoinsDto>> {
  const rb = new RequestBuilder(rootUrl, getUserControllerGetJoin.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserCenterJoinsDto>;
    })
  );
}

getUserControllerGetJoin.PATH = '/api/user/join';
